var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNuxtJs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "React",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00C492;}\r\n\t.st1{fill:#008776;}\r\n\t.st2{fill:#2D4A5D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g862",
    transform: "matrix(2.5377204,0,0,2.5377204,-12.870824,-44.131613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12",
    className: "st0",
    d: "M25.5,44.3c0,0,0-0.1-0.1-0.1c-0.1-0.2-0.1-0.5-0.1-0.8h-6.3L28.4,27l3.1,5.4l0.9-1.6l-2.7-4.7 c-0.3-0.5-0.7-0.8-1.3-0.9c-0.6,0-1,0.4-1.3,0.9l-9.4,16.6c-0.3,0.5-0.3,1.1-0.1,1.6c0.3,0.5,0.8,0.7,1.4,0.7h7.9 C26.3,45,25.8,44.8,25.5,44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    className: "st1",
    d: "M43.7,42.7l-7.8-13.7c-0.3-0.5-0.8-0.8-1.3-0.9c-0.6,0-1,0.4-1.3,0.9l-1,1.8l0.9,1.6l1.4-2.4 l7.7,13.5h-2.9c0,0.2,0,0.5-0.1,0.7c0,0,0,0.1-0.1,0.1l0,0c-0.3,0.5-0.8,0.7-1.4,0.7h4.6c0.6,0,1.1-0.2,1.4-0.7 C44,43.8,44,43.2,43.7,42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    className: "st2",
    d: "M39.2,44.3L39.2,44.3c0-0.1,0.1-0.1,0.1-0.2c0.1-0.2,0.1-0.4,0.1-0.7c0-0.2-0.1-0.5-0.3-0.7 l-5.9-10.3l-0.9-1.6l-0.9,1.6l-5.9,10.3c-0.1,0.2-0.2,0.4-0.2,0.7c0,0.3,0,0.5,0.1,0.8c0,0,0,0.1,0.1,0.1c0.3,0.5,0.8,0.7,1.4,0.7 h10.9C38.4,45,38.9,44.7,39.2,44.3z M32.3,34l5.4,9.4H27L32.3,34z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuxtJs);
export default __webpack_public_path__ + "static/media/NuxtJS.36c5409ace0ea90319c3e1f6740c2710.svg";
export { ForwardRef as ReactComponent };